<div class="grid grid-cols-5 gap-2" [formGroup]="form" [class]="showTitle() ? '[grid-template-rows:15px_repeat(4,1fr)]' : 'grid-rows-4'">
  @if (showTitle()) {
    <div class="col-start-3 flex items-center justify-center font-thin">
      <ng-container [ngTemplateOutlet]="isRightSide() ? distalTitle : mesialTitle" />
    </div>
    <div class="flex items-center justify-center font-thin">
      <span class="text-h6">{{ 'perio_exam_measurement_central_letter' | translate }}</span>
    </div>
    <div class="flex items-center justify-center font-thin">
      <ng-container [ngTemplateOutlet]="isRightSide() ? mesialTitle : distalTitle" />
    </div>
  }

  <!-- Pocket depth row with gradient background when in pocket depth mode and this side is active -->
  <lib-perio-number-config-measurement
    [showGradient]="inputMode() === 'pocketDepth' && !disabled()"
    [formGroup]="form.controls.pocketDepth"
    [side]="side()"
    [readonly]="disabled()"
    [rowLabel]="'perio_exam_pocket_depth_acronym' | translate"
    [isDcm]="isRightSide()"
    [reversed]="reversedMeasurementOrder()"
    [activeCursor]="activePocketDepthCursor()"
    [fgDisabled]="!(toothPosition() | hasFg)"
    colorVariant="purple"
  ></lib-perio-number-config-measurement>

  <lib-perio-boolean-config-measurement
    [formGroup]="form.controls.bleedingOnProbing"
    [side]="side()"
    [readonly]="disabled()"
    [rowLabel]="'perio_exam_bleeding_on_probing_acronym' | translate"
    [reversed]="reversedMeasurementOrder()"
    [activeCursor]="activeSurface()"
    colorVariant="red"
  ></lib-perio-boolean-config-measurement>

  <lib-perio-boolean-config-measurement
    [formGroup]="form.controls.suppuration"
    [side]="side()"
    [readonly]="disabled()"
    [rowLabel]="'perio_exam_suppuration_acronym' | translate"
    [reversed]="reversedMeasurementOrder()"
    [activeCursor]="activeSurface()"
    colorVariant="orange"
  ></lib-perio-boolean-config-measurement>

  <!-- Recession row with gradient background when in recession mode and this side is active -->
  <lib-perio-number-config-measurement
    [showGradient]="inputMode() === 'recession' && !disabled()"
    [formGroup]="form.controls.rec"
    [side]="side()"
    [readonly]="disabled()"
    [isDcm]="isRightSide()"
    [rowLabel]="'perio_exam_recession_acronym' | translate"
    [reversed]="reversedMeasurementOrder()"
    [activeCursor]="activeRecessionCursor()"
    [fgDisabled]="!(toothPosition() | hasFg)"
    [disabledRecession]="isCentralRecession()"
    colorVariant="pink"
  ></lib-perio-number-config-measurement>
</div>

<ng-template #distalTitle>
  <span class="text-h6">{{ 'perio_exam_measurement_distal_letter' | translate }}</span>
</ng-template>
<ng-template #mesialTitle>
  <span class="text-h6">{{ 'perio_exam_measurement_mesial_letter' | translate }}</span>
</ng-template>
